import type {FeatureFlag, FeatureFlagKey} from '../types'

export const checkFeatureFlag = (featureFlags: FeatureFlag[], key: FeatureFlagKey): boolean => {
  if (!featureFlags || featureFlags.length === 0) {
    return false
  }

  // keys are matched case-insensitively: the config returns some keys in a different casing (e.g. StorageLevels vs storageLevels)
  const normalizedKey = key.toLowerCase()
  const flag = featureFlags.find((f) => f.key.toLowerCase() === normalizedKey)
  return flag?.value === true
}
